export const getOrderDescription = (items: any[]) => {
  return items?.length > 1
    ? `${items.length} artículos`
    : items?.map((i) => i.productName).toString() || " - ";
};
